import produce from 'immer';

import {
  ADD_NOTIFICATION,
  ADD_TOAST_NOTIFICATION,
  CLEAR_ALL_ALERTS,
  CLEAR_ERROR,
  CLEAR_NOTIFICATION,
  ERROR,
  FETCHING_COMPLETE,
  IS_FETCHING,
} from '@actions/appState';

const initialState: IAppStateStore = {
  loadingComponents: 0,
  alerts: [],
  showToast: false,
};

export default (state: IAppStateStore = initialState, action: any) =>
  produce(state, (draftState: IAppStateStore) => {
    switch (action.type) {
      case IS_FETCHING:
        if (!action.hideLoadingWidget) {
          draftState.loadingComponents++;
        }

        return;

      case FETCHING_COMPLETE:
        if (!action.hideLoadingWidget) {
          draftState.loadingComponents--;
        }

        return;

      case ERROR: {
        const key = new Date().getTime();
        if (!action.hideLoadingWidget) {
          draftState.loadingComponents--;
        }
        const isDismissible = action.errorDismissible;
        if (action.errorMessage) {
          const newAlert: IAlert = {
            type: AlertLevel.ERROR,
            isDismissible,
            key,
            message: action.errorMessage,
          };
          draftState.alerts.push(newAlert);
        }

        return;
      }

      case ADD_NOTIFICATION: {
        const key = new Date().getTime();
        const isDismissible = action.errorDismissible;
        const newAlert: IAlert = {
          type: AlertLevel.SUCCESS,
          isDismissible,
          key,
          message: action.notificationText,
        };
        draftState.alerts.push(newAlert);

        return;
      }

      case CLEAR_NOTIFICATION: {
        const notificationKey = action.notificationKey;
        draftState.alerts = draftState.alerts.filter(
          (alert) => alert.type !== AlertLevel.SUCCESS || alert.key !== notificationKey
        );

        return;
      }

      case CLEAR_ERROR: {
        const errorKey = action.errorKey;
        draftState.alerts = draftState.alerts.filter(
          (alert) => alert.type !== AlertLevel.ERROR || alert.key !== errorKey
        );

        return;
      }

      case CLEAR_ALL_ALERTS:
        draftState.alerts = [];

        return;

      case ADD_TOAST_NOTIFICATION:
        draftState.showToast = action.value;

        return;
    }
  });
